import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";

class GmapLogParam {
    apiType: string;
    category: string;
    channel: string = 'tradlinx';
    param: string = null;
    userId: number = null;
}


@Injectable()
export class GmapLogService {
    constructor(private http: HttpClient) {
    }




    log(category: string, apiType: string, param?: string) {

        const body: GmapLogParam = new GmapLogParam();
        body.category = category;
        body.apiType = apiType;

        if (param) {
            body.param = param;
        }
        
        let reqOptions = {
            headers: new HttpHeaders({
                'tx-clientid': 'tradlinx'
            }),
            params: null,
            body: body,
        }

        this.http.request('POST', 'https://api.tradlinx.com/log/gmap', reqOptions).subscribe();


    }

}


// WEBPACK FOOTER //
// ./src/app/services/gmap-log.service.ts